import { API } from "./api";
export const createPayment = (paymentData) =>
  API.post(`/payment/create`, paymentData);
